import telemetryFieldMappings from './telemetryFieldMappings.json';

const { _generated, ...ALIAS_MAP } = telemetryFieldMappings;

/**
 * Versioned batch of TelemetryEvent instances. toAlias() is explicit (not the
 * MappingBase reverse-lookup) because `events` is an ARRAY of model instances
 * that must each be aliased — MappingBase only renames top-level keys.
 */
export default class TelemetryBatch {
  constructor({ schema_version, jwt, events } = {}) {
    this.schema_version = schema_version;
    this.jwt = jwt;
    this.events = events || [];
  }

  toAlias() {
    const out = {
      [invert('schema_version')]: this.schema_version,
      [invert('events')]: this.events.map((e) => e.toAlias()),
    };
    if (this.jwt != null) out[invert('jwt')] = this.jwt;
    return out;
  }
}

// field-name → alias (one-time, tiny map).
function invert(fieldName) {
  for (const [alias, field] of Object.entries(ALIAS_MAP)) {
    if (field === fieldName) return alias;
  }
  return fieldName;
}
